import { Component, OnInit } from '@angular/core';
import { InvoiceLineItemUpsertDto } from 'src/app/invoices/dto/invoice-line-item-upsert.dto';
import { InvoiceUpsertDto } from 'src/app/invoices/dto/invoice-upsert.dto';
import { InvoiceCalculationsDto } from '../shared/invoice/invoice-utility/dto/invoice-calculations.dto';
import { InvoiceUtilityService } from '../shared/invoice/invoice-utility/invoice-utility.service';

@Component({
  selector: 'wl-invoice-line-item-details-dialog',
  templateUrl: './invoice-line-item-details-dialog.component.html',
  styleUrls: ['./invoice-line-item-details-dialog.component.less'],
    standalone: false
})
export class InvoiceLineItemDetailsDialogComponent implements OnInit {
  invoice?: InvoiceUpsertDto;
  selectedLineItemId?: number;
  flattenedLineItems: InvoiceLineItemUpsertDto[] = [];
  invoiceCalculations: InvoiceCalculationsDto;
  showDialog = false;

  constructor(private _invoiceUtilityService: InvoiceUtilityService) {}

  ngOnInit(): void {}

  public open(invoice: InvoiceUpsertDto, selectedLineItemId?: number) {
    this.showDialog = true;
    this.invoice = invoice;
    if (this.invoice) {
      this.invoiceCalculations = this._invoiceUtilityService.calculateInvoiceTotals(this.invoice);
    }
    if (invoice.LineItems?.length) {
      for (const lineItem of invoice.LineItems) {
        this.flattenedLineItems.push(lineItem);
        if (lineItem.TaxLineItems?.length) {
          this.flattenedLineItems.push(...lineItem.TaxLineItems);
        }
      }
    }
    this.selectedLineItemId = selectedLineItemId;
  }

  close() {
    this.showDialog = false;
    this.flattenedLineItems = [];
  }
}
